import { useMemo, useState } from "react";
import { channels, replies } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

const cats = ["全部", ...channels.map((c) => c.name)];

export default function ReplyFeed() {
  const [active, setActive] = useState("全部");
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const list = useMemo(
    () => (active === "全部" ? replies : replies.filter((r) => r.category === active)),
    [active]
  );

  const toggle = (id: number) => setLiked((p) => ({ ...p, [id]: !p[id] }));

  return (
    <section id="reply" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          center
          kicker="吃瓜神回复 · 评论区的精华"
          title="神回复区，笑到弯腰也要点赞"
          desc="楼主负责抛瓜，评论区负责封神。这里精选的每一条网友神回复，都配得上「评论区才是瓜的精华」这句话。"
        />

        {/* 频道筛选 */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* 神回复卡片 */}
        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {list.map((r) => {
            const isLiked = !!liked[r.id];
            return (
              <article
                key={r.id}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:shadow-sm"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-200 text-base font-semibold text-secondary-900">
                    {r.author.charAt(0)}
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-foreground-800">{r.author}</p>
                    <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                      神回复：“{r.post}”
                    </p>
                  </div>
                  <span className="ml-auto whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
                    {r.tag}
                  </span>
                </div>

                <p className="mt-4 flex-1 text-[15px] leading-relaxed text-foreground-800">
                  {r.text}
                </p>

                <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <button
                    type="button"
                    onClick={() => toggle(r.id)}
                    aria-label="点赞"
                    className={`inline-flex items-center gap-1 whitespace-nowrap transition-colors ${
                      isLiked ? "text-accent-500" : "hover:text-accent-500"
                    }`}
                  >
                    <i className={isLiked ? "ri-heart-fill" : "ri-heart-line"}></i>
                    {(r.likes + (isLiked ? 1 : 0)).toLocaleString()}
                  </button>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-chat-3-line"></i>
                    {r.comment}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line"></i>
                    {r.time}
                  </span>
                </div>
              </article>
            );
          })}
        </div>

        {list.length === 0 && (
          <p className="mt-8 text-center text-sm text-foreground-500">该频道的神回复正在加紧收录中，稍后再来看看～</p>
        )}
      </div>
    </section>
  );
}